export default __webpack_public_path__ + "static/media/Ubuntu-C.24ff791f.woff";